const getDefaultState = () => {
	return {
		// The validation is stored to enable the contact info step to be refreshed without requiring
		// communication via the rdc resource in the bvmop-xc-funnel-premium-service
		storedCocValidation: {},

		contactInfo: {
			coc : null,
			companyData: {
				companyName: null,
				companyStreetName: null,
				companyHouseNumber: null,
				companyPostalCode: null,
				companyCityName: null,
			},
			sameRiskAddress: 'y',
			manualRiskAddress: {
				streetName: null,
				houseNumber: null,
				houseNumberAddition: null,
				postalCode: null,
				city: null,
			},
			name : null,
			email : null,
			phoneNumber : null
		},

		companyProfile: {
			tradestockPresent : null,
			buildingOwnership : null,
			buildingRental : null,
			valueTenantInterest : null,
			inventoryPresent : null,
			employees : null,
			thirdPartyVehicleStorage : null,
			alarmWithReporting : null,
			bovagMembership : null
		},

		companyInfo: {
			upperManagementAmount : null,
			uniformSalary : null,
			nonSalariedEmployees : null,
			drivingRisks : null,
			averageCatalogValueDrivingRisks : null,
			tradestockMaxValue : null,
			companyBuildingRebuildValue : null,
			valueInventory : null,
			valueGoods : null,
			valueTires : null
		},

		additionalRisks: {
			insureFinancialDamage : null,
			legalAssistance : null,
			financialBurden : null,
			remarks : null
		}
	};
}

const TYPE_YES_NO = "YES_NO";
const TYPE_TEXT = "TEXT";
const TYPE_NUMBER = "NUMBER";
const TYPE_CURRENCY = "CURRENCY";

export default {
	namespaced: true,
	state: {
		...getDefaultState()
	},
	mutations: {
		setCocValidation(state, value) {
			state.storedCocValidation = value;
		},
		setUniformSalary(state, value) {
			state.companyInfo.uniformSalary = value;
		},
		setTradestockMaxValue(state, value) {
			state.companyInfo.tradestockMaxValue = value;
		},
		setCompanyBuildingRebuildValue(state, value) {
			state.companyInfo.companyBuildingRebuildValue = value;
		},
		setValueInventory(state, value) {
			state.companyInfo.valueInventory = value;
		},
		setValueGoods(state, value) {
			state.companyInfo.valueGoods = value;
		},
		setValueTires(state, value) {
			state.companyInfo.valueTires = value;
		},
		setContactInfo(state, value) {
			state.contactInfo = value;
		},
		setCompanyProfile(state, value) {
			state.companyProfile = value;
		},
		setCompanyInfo(state, value) {
			state.companyInfo = value;
		},
		setAdditionalRisks(state, value) {
			state.additionalRisks = value;
		},
		resetState(state) {
			Object.assign(state, getDefaultState());
		}
	},
	getters: {
		getPostData: (state) => {
			let postData = {
				coc: state.contactInfo.coc,
				sameRiskAddress: { questionType: TYPE_YES_NO, questionCode: "<unused>", answer: state.contactInfo.sameRiskAddress },
				manualRiskAddress: state.contactInfo.manualRiskAddress,
				name: state.contactInfo.name,
				emailAddress: state.contactInfo.email,
				telephone: state.contactInfo.phoneNumber,
				companyProfile: [
					{ questionType: TYPE_YES_NO, questionCode: "tradestock_present", answer: state.companyProfile.tradestockPresent },
					{ questionType: TYPE_YES_NO, questionCode: "building_ownership", answer: state.companyProfile.buildingOwnership },
					{ questionType: TYPE_YES_NO, questionCode: "building_rental", answer: state.companyProfile.buildingRental },
					{ questionType: TYPE_CURRENCY, questionCode: "value_tenant_interest", answer: state.companyProfile.valueTenantInterest },
					{ questionType: TYPE_YES_NO, questionCode: "inventory_present", answer: state.companyProfile.inventoryPresent },
					{ questionType: TYPE_YES_NO, questionCode: "employees", answer: state.companyProfile.employees },
					{ questionType: TYPE_YES_NO, questionCode: "third_party_vehicle_storage", answer: state.companyProfile.thirdPartyVehicleStorage },
					{ questionType: TYPE_YES_NO, questionCode: "alarm_with_reporting", answer: state.companyProfile.alarmWithReporting },
					{ questionType: TYPE_YES_NO, questionCode: "bovag_membership", answer: state.companyProfile.bovagMembership }
				],
				companyInformation: [
					{ questionType: TYPE_NUMBER, questionCode: "upper_management_amount", answer: state.companyInfo.upperManagementAmount },
					{ questionType: TYPE_CURRENCY, questionCode: "uniform_salary", answer: state.companyInfo.uniformSalary },
					{ questionType: TYPE_NUMBER, questionCode: "non_salaried_employees", answer: state.companyInfo.nonSalariedEmployees },
					{ questionType: TYPE_NUMBER, questionCode: "driving_risks", answer: state.companyInfo.drivingRisks },
					{ questionType: TYPE_CURRENCY, questionCode: "average_catalog_value_driving_risks", answer: state.companyInfo.averageCatalogValueDrivingRisks },
					{ questionType: TYPE_CURRENCY, questionCode: "tradestock_max_value", answer: state.companyInfo.tradestockMaxValue },
					{ questionType: TYPE_CURRENCY, questionCode: "company_building_rebuild_value", answer: state.companyInfo.companyBuildingRebuildValue },
					{ questionType: TYPE_CURRENCY, questionCode: "value_inventory", answer: state.companyInfo.valueInventory },
					{ questionType: TYPE_CURRENCY, questionCode: "value_goods", answer: state.companyInfo.valueGoods },
					{ questionType: TYPE_CURRENCY, questionCode: "value_tires", answer: state.companyInfo.valueTires }
				],
				additionalRisk: [
					{ questionType: TYPE_YES_NO, questionCode: "insure_financial_damage", answer: state.additionalRisks.insureFinancialDamage },
					{ questionType: TYPE_YES_NO, questionCode: "legal_assistance", answer: state.additionalRisks.legalAssistance },
					{ questionType: TYPE_CURRENCY, questionCode: "financial_burden", answer: state.additionalRisks.financialBurden },
					{ questionType: TYPE_TEXT, questionCode: "remarks", answer: state.additionalRisks.remarks }
				]
			};

			// Remove unanswered questions
			postData.companyProfile = postData.companyProfile.filter(question => question.answer !== null);
			postData.companyInformation = postData.companyInformation.filter(question => question.answer !== null);
			postData.additionalRisk = postData.additionalRisk.filter(question => question.answer !== null);

			return postData;
		}
	}
}
